export const BoxArrowRow = {
  bindings: {
    arrowLeft: '<',
    color: '@',
  },

  template: `
    <div class="box-arrow-row"
      ng-class="{ 'theme-white': $ctrl.color === 'white' }">
      <span class="box-arrow" style="left: {{ $ctrl.arrowLeft }}%"></span>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Box/BoxArrowRow.js